document.addEventListener("DOMContentLoaded", function () {

	document.addEventListener('click', function (event) {

		//if the clicked element is a scroll to top buttom
		if (event.target.classList.contains('scroll-to-top')) {

            //prevent the default behaviour
			event.preventDefault();

            //scroll to the top of the page
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
		}
	}, false);
});